import React from 'react';


const GrowthIllustrationBottom = () => (
  <svg
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
    width="261"
    height="251"
    viewBox="0 0 261 251"
  >
    <g fill="none">
      <path
        fill="#00E191"
        d="M162.804 216.217c-11.802-20.339-8.464-46.069 8.136-62.723 16.6-16.655 42.32-20.077 62.696-8.342 20.378 11.734 30.327 35.697 24.254 58.413-6.072 22.717-26.651 38.519-50.166 38.52-18.532.07-35.678-9.804-44.92-25.868z"
        transform="translate(.5 .379)"
      />
      <path
        fill="#FF8900"
        d="M207.724 59.964v78.26c-18.573 0-35.73 9.92-45 26.014-9.27 16.094-9.24 35.913.08 51.979l-58.942 34.026V119.917L207.713 59.96l.011.005z"
        transform="translate(.5 .379)"
      />
      <path
        fill="#E6983E"
        d="M103.862 119.917L67.694 99.037 171.551 39.078 207.713 59.959z"
        transform="translate(.5 .379)"
      />
      <path
        fill="#FFA946"
        d="M103.862 119.917L103.862 250.243 0 190.279 0 59.964 0.011 59.959 41.22 83.755 41.22 170.172 53.797 164.978 67.51 180.558 67.51 99.145 67.694 99.037z"
        transform="translate(.5 .379)"
      />
      <path
        fill="#FFF"
        d="M67.694 99.037L67.51 99.145 67.51 180.558 53.797 164.978 41.22 170.172 41.22 83.755 41.226 83.755zM224.607 174.154c1.225 0 2.217 1.09 2.217 2.435v18.021c0 1.346-.991 2.436-2.217 2.436-1.224 0-2.216-1.09-2.216-2.436l-.001-12.47-11.155 12.195c-.821.897-2.126.937-2.99.118l-.12-.123-3.589-3.943-12.902 14.03c-.43.468-.99.7-1.55.7-.567 0-1.133-.239-1.564-.717-.856-.95-.849-2.48.016-3.42l14.459-15.723c.86-.937 2.249-.932 3.105.009l3.585 3.938 9.313-10.18h-10.795c-1.173 0-2.133-1.001-2.211-2.268l-.006-.167c0-1.345.993-2.435 2.217-2.435z"
        transform="translate(.5 .379)"
      />
      <path
        fill="#D3D3D2"
        d="M171.551 39.078L67.694 99.037 41.226 83.755 145.077 23.796z"
        transform="translate(.5 .379)"
      />
      <path
        fill="#E6983E"
        d="M103.862 0L145.077 23.796 41.226 83.755 41.22 83.755 0.011 59.959z"
        transform="translate(.5 .379)"
      />
    </g>
  </svg>
);

export default GrowthIllustrationBottom;
